<template>
  <section class="section">
    <div class="container">
      <ul class="filter__wrapper justify-content-center">
        <li>
          <button
            @click="filterNews(null)"
            :class="['btn btn-secondary', { active: activeClubId === null }]"
          >
            Alle ({{ clubNews.length }})
          </button>
        </li>
        <li v-for="club in clubs" :key="club.id">
          <button v-if='club.id !== 1'
            @click="filterNews(club.id)"
            :class="['btn', { active: activeClubId === club.id }]"
            :style="{ backgroundColor: club.backgroundColor ? 'var(' + club.backgroundColor + ')' : '' }"
          >
            {{ club.name }} ({{ getClubNewsCount(club.id) }})
          </button>
        </li>
      </ul>
    </div>
  </section>
</template>

<script>
import { ref, onMounted, toRefs, watch } from "vue";
import axios from 'axios';

export default {
  name: "NewsFilter",
  props: {
    clubNews: Array
  },
  setup(props, { emit }) {
    const { clubNews } = toRefs(props);

    // Clubs von der API laden
    const clubs = ref([]);
    const activeClubId = ref(null);

    const fetchData = async() => {
      try {
        const response = await axios.get('http://localhost:8082/gemeinde/clubs');
        clubs.value = response.data;
        filterNews(null);
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    };

    // Methode zum Filtern der Nachrichten
    const filterNews = (clubId = null) => {
      activeClubId.value = clubId;
      let filtered;
      if (clubId) {
        filtered = clubNews.value.filter(news => news.clubId === clubId);
      } else {
        filtered = clubNews.value;
      }
      emit('filtered', filtered); // Die gefilterten Nachrichten werden an die Elternkomponente weitergegeben
    };

    onMounted(() => {
      fetchData();
    });

    // Methode um News nach Club ID zu zählen
    const getClubNewsCount = (clubId) => {
      return props.clubNews.filter(news => news.clubId === clubId).length;
    };

    // Methode, um einen Club nach ID zu finden (optional, falls du das brauchst)
    const getClubById = (clubId) => {
      return clubs.value.find(club => club.id === clubId);
    };

    // Watcher für clubNews: Filter anwenden, sobald News geladen sind
    watch(clubNews, (newVal) => {
      if (newVal && newVal.length > 0 && activeClubId.value === null) {
        filterNews(null);
      }
    }, { immediate: true });

    // Rückgabe der reaktiven Daten und Methoden
    return {
      clubs,
      getClubNewsCount,
      getClubById,
      filterNews,
      activeClubId
    };
  }
};
</script>

<style></style>
